import transactionBillingService from '../../../services/notisphere/transactionBilling'
import { OUTPUT_DATE_FORMAT} from '../../../misc/commons'
import moment from 'moment-timezone'
export default {
    props: {
        organizationId: { type: String, default: null },
        organizationName: { type: String, default: null },
        billingFromDate: { type: Date, default: new Date(new Date().getFullYear(), new Date().getMonth(), 1) },
        billingToDate: { type: Date, default: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0) },
        billing_filter_val: { type: String, default: 'current_month' },
    },
    data() {
        const billing_from_date = this.billingFromDate
        const billing_to_date = this.billingToDate
        return {
            billing_from_date: billing_from_date,
            billing_to_date: billing_to_date,
            item: null,
            OUTPUT_DATE_FORMAT: OUTPUT_DATE_FORMAT,
            billingFilterVal: this.billing_filter_val,
            billingPeriodOptions: [{ value: 'current_month', text: 'Current Month' }, { value: 'last_month', text: 'Last Month' }, { value: 'year_to_date', text: 'Year To Date' }, { value: 'is_custom_selected_date', text: 'Custom' }]
        }
    },
    watch: {

        billingFilterVal(val) {

            switch (val) {

            case 'current_month': {
                const today = new Date()
                this.billing_from_date = new Date(today.getFullYear(), today.getMonth(), 1)
                this.billing_to_date = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                break
            }

            case 'last_month': {
                const lastMonth = new Date()
                this.billing_from_date = new Date(lastMonth.getFullYear(), lastMonth.getMonth() - 1, 1)
                this.billing_to_date = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 0)
                break
            }

            case 'year_to_date': {
                const today = new Date()
                this.billing_from_date = new Date(today.getFullYear(), 0, 1)
                this.billing_to_date = today
                break
            }
            default:
                break
            }
        }
    },
    computed: {
        formattedBillingFromDate() {
            return moment(this.billing_from_date).format('YYYY/MM/DD')
        },
        formattedBillingToDate() {
            return moment(this.billing_to_date).format('YYYY/MM/DD')
        },
        hasAnySchemeName() {
            return Object.values(this.groupedData || {}).some(group => group.schemeName)
        },
        groupedData() {
            const groups = {}
            if (!this.item) return groups
            for (const entry of this.item) {
                const schemeId = entry.ratingSchemeId
                if (!groups[schemeId]) {
                    groups[schemeId] = {
                        schemeName: entry.ratingSchemeName,
                        schemeStartDate: entry.ratingSchemeStartDate,
                        schemeEndDate: entry.ratingSchemeEndDate,
                        transactions: [],
                        total: 0
                    }
                }
                groups[schemeId].transactions.push(entry)
                groups[schemeId].total += entry.totalCost
            }
            return groups
        },
        grandTotal() {
            if (Array.isArray(this.item)) {
                return this.item.reduce((sum, item) => sum + Number(item.totalCost || 0), 0)
            }
            return 0.00
        }
    },
    created() {
        this.getBillingDetailsById()
    },
    methods: {
        btnApplyDateFilterClick() {
            if (!this.isOneYearDateRangeValid()) {
                this._showToast('Please select a date range within a one-year period.', { variant: 'danger' })
                return
            }
            if (this.billing_from_date && this.billing_to_date) {
                const fromDate = new Date(this.billing_from_date)
                const toDate = new Date(this.billing_to_date)
                if (toDate >= fromDate) {
                    this.getBillingDetailsById()
                }
                else {
                    this._showToast('To Date should be greater than From Date', { variant: 'danger' })
                }
            }
            else {
                this._showToast('Please select both From and To dates to apply the filter', { variant: 'danger' })
            }
        },
        getBillingDetailsById() {
            transactionBillingService.getBillingDetailsById(this.organizationId, this.formattedBillingFromDate, this.formattedBillingToDate).then(resp => {
                if (!resp.error){
                    this.item = resp.data.d
                }
            })
        },
        downloadTransactionDetailsReport() {
            transactionBillingService.downloadTransactionDetailsReport(this.organizationId, this.formattedBillingFromDate, this.formattedBillingToDate).then(resp => {})
        },
        getTotal(items) {
            return items.reduce((sum, item) => sum + item.totalCost, 0)
        }
    }
}